import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('./pages/EditorPage.vue')
  },
  {
    path: '/preview',
    name: 'preview',
    component: () => import('./pages/PreviewPage.vue')
  }
];

export const router = createRouter({
  history: createWebHistory(),
  routes
});
